import React from "react"
import ReactGA from "react-ga4"
import { useSelector } from "react-redux"
import { FormattedMessage } from "react-intl"

import CustomLink from "../../../common/CustomLink"
import { Tabs } from "../../../common"
import { GA_EVENTS } from "../../../../constants/analytics"
import { useIntl } from "react-intl"
import { PLAN_TYPES, TALK_TO_US_URL } from "../../../../constants"

const tabItems = [
  {
    value: PLAN_TYPES.PREMIUM,
    variant: "secondary",
  },
  {
    value: PLAN_TYPES.ENTERPRISE,
    variant: "primary",
  }
]

const Hero = ({planType, setPlanType}) => {
  const { formatMessage } = useIntl();
  const team = useSelector((state) => state.auth.team);

  const setSelected = (selected) => {
    ReactGA.event(GA_EVENTS.CHOOSE_PRICING[selected] ?? GA_EVENTS.CHOOSE_PRICING.TAB_SELECTED)
    setPlanType(selected)
  }

  const backToLink = team.subscriptionType === "Incomplete"
    ? "/company-info"
    : "/job-match/select-cv";

  return (
    <div className="hero">
      <img
        src={"/img/landing/PayAsYouGo.png"}
        alt={"payAsYouGo"}
        className="hero__image"
      />

      <div className="hero__wrapper">
        <div className="hero__back-link">
          <p className="hero__text">
            <CustomLink className="back-link" to={backToLink}>
              <FormattedMessage id="common.goBack" />
            </CustomLink>
          </p>
        </div>

        <Tabs
          useItemVariants
          items={tabItems.map(({ value, variant }) => ({
            value,
            label: formatMessage({ id: `common.${value}` }),
            variant,
          }))}
          selected={planType}
          setSelected={setSelected}
        />

        <>
          <div className="hero__content">
            <p className="hero__text">
              {/* <b>{"Let's calculate pricing to fit only what you need."}</b> */}
              <b><FormattedMessage id="choosePricing.hero.subtitle" /></b>
              {" "}
              <FormattedMessage id="choosePricing.hero.subtitle2" />
              {" "}
              <CustomLink to={TALK_TO_US_URL} target="_blank">
                <FormattedMessage id="choosePricing.hero.subtitleLink" />
              </CustomLink>
            </p>
          </div>
        </>
      </div>
    </div>
  )
}

export default Hero
